import * as React from 'react';
import { SvgComponentProps, Svg } from './svg-component';

export const ClockFillIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 16} height={size || 16} viewBox="0 0 16 16" fill="none" {...rest}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm.714-10.857a.714.714 0 0 0-1.428 0V8c0 .167.058.329.165.457l2.857 3.429a.714.714 0 0 0 1.098-.915l-2.692-3.23V5.143Z"
            fill="currentColor"
        />
    </Svg>
);
